import { API_URL } from "../../helpers/crud-helper/consts";
import axios from "axios";

const SUBSCRIPTION_LINK = `${API_URL}/subscription`;

const SubscriptionPlan = (
  plan: any,
  currentLanguageCode: any
): Promise<any> => {
  return axios
    .get(`${SUBSCRIPTION_LINK}/${plan}?language=${currentLanguageCode}`)
    .then((response) => response.data.data);
};


const codeStatusRequest = (value : any): Promise<any> => {
  return axios
      .post(`${SUBSCRIPTION_LINK}-url-status`, value)
      .then((response) => response)
};

export { SubscriptionPlan, codeStatusRequest };









